export default __webpack_public_path__ + "static/media/hike.efc63d77.png";